module.exports = __webpack_public_path__ + "img/marc.101b9dc3.jpg";